import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';

@Component({
  selector: 'app-select-survey-modal',
  templateUrl: './select-survey-modal.component.pug',
  styleUrls: ['./select-survey-modal.component.scss'],
  standalone: false
})
export class SelectSurveyModalComponent implements OnInit {
  public selectClick: EventEmitter<any> = new EventEmitter();
  exitButtonChangeText = false;
  createRefSurvey = false;
  createPulseSurvey = false;
  createExitSurvey = false;
  refAccessTooltip = "";
  pulseAccessTooltip = "";
  exitAccessTooltip = "";

  constructor(
    public bsModalRef: BsModalRef,
    private permission: PermissionsService
  ) {
  }

  ngOnInit(): void {
     this.createRefSurvey = this.permission.hasPermission('can_create_reference_surveys')
     this.createPulseSurvey = this.permission.hasPermission('can_create_pulse_surveys')
     this.createExitSurvey = this.permission.hasPermission('can_create_exit_surveys')
     this.refAccessTooltip = !this.createRefSurvey ? $localize`Contact your Reference administrator to gain access to this feature.` : '';
     this.pulseAccessTooltip = !this.createPulseSurvey ? $localize`Contact your Pulse administrator to gain access to this feature.` : '';
     this.exitAccessTooltip = !this.createExitSurvey ? $localize`Contact your Exit administrator to gain access to this feature.` : '';
  }

  select(surveyType): void {

    if ((surveyType === 'reference' && !this.createRefSurvey) ||
      (surveyType === 'pulse' && !this.createPulseSurvey) ||
      (surveyType === 'exit' && !this.createExitSurvey)) {
      return;
    }

    this.selectClick.emit({ data: surveyType});
    this.bsModalRef.hide();
    this.permission.setNavCheck(false);
  }

  cancel(): void {
    this.bsModalRef.hide();
  }
}
